var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blessing-bag-item cursor-pointer",style:(_vm.blessingStyle)},[_c('div',{staticClass:"blessing-bag-label-wrap",style:(_vm.wrapStyle)},[_c('span',{staticClass:"whitespace-nowrap"},[_vm._v(_vm._s(_vm.item.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }